// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m8-c";
export var backButton = "_m8-4";
export var backIcon = "_m8-5";
export var chevronShortcut = "_m8-6";
export var container = "_m8-1";
export var editor = "_m8-8";
export var editorWrapper = "_m8-7";
export var prefix = "_m8-2";
export var searchIcon = "_m8-3";
export var suffix = "_m8-9";
export var suffixContent = "_m8-a";
export var suffixText = "_m8-b";
export var wrapper = "_m8-0";